<template>
    <b-container fluid>
        <hr/>
        <h3>API Calls</h3>
        <hr/>

        <v-skeleton-loader
                :loading="this.loadingData"
                ref="skeleton"
                type="image"
                class="mx-auto"
                width="100%"
                height="100px">
            <div class="row justify-content-around">
                <div class="col-12 col-xl-3">
                    <h6>Project</h6>
                    <b-form-select :options="availableProjectNames" v-model="selectedProject"/>
                </div>
                <div class="col-12 col-xl-3">
                    <h6>API</h6>
                    <b-form-select :options="availableAPIs" v-model="selectedApi" :disabled="selectedProject == null"/>
                </div>
                <div class="col-12 col-xl-3">
                    <br>
                    <b-button class="refreshButton" :disabled="selectedApi == null" @click="refreshAllData">Refresh all
                        data
                    </b-button>
                </div>
            </div>
        </v-skeleton-loader>

        <hr/>
        <!------------------------------------------------------------------------------------------------------------------------->
        <div class="chartContainer">
            <div id="callInfo" class="infoBox flexRow">
                <div id="dailyCallRatio" class="dailyCallRatioChart col-12 col-xl-3">
                    <v-skeleton-loader
                            :loading="this.loadingData"
                            transition='scale-transition'
                            ref="skeleton"
                            type="image"
                            class="mx-auto"
                            width="300">

                        <v-card class="dailyCallCard">
                            <h1>{{callsMadeToday}} <span v-if="isLimited">/50000</span></h1>
                            <h5>calls made today <br> to {{selectedApi}}</h5>
                        </v-card>

                    </v-skeleton-loader>
                </div>
                <v-divider vertical class="dailyCallDivider"/>
                <div id="dailyCallChart" class="dailyCallChart col-12 col-xl-8">
                    <v-skeleton-loader
                            :loading="this.loadingData"
                            transition='scale-transition'
                            ref="skeleton"
                            type="image"
                            class="mx-auto"
                            width="100%">
                        <v-card>
                            <apexchart height="300px" type="line" :options="dailyCallChartOptions"
                                       :series="dailyCallChartSeries"/>
                        </v-card>
                    </v-skeleton-loader>
                </div>
            </div>
            <hr>
            <div id="historyCallChart" class="col-12">
                <v-skeleton-loader
                        :loading="this.loadingData"
                        transition='scale-transition'
                        ref="skeleton"
                        type="image"
                        class="mx-auto"
                        width="100%">
                    <v-card>
                        <apexchart v-if="!isLoading" height="500px" type="line"
                                   :options="callHistoryChartOptions"
                                   :series="callHistoryChartSeries"/>
                    </v-card>
                </v-skeleton-loader>
            </div>
        </div>
    </b-container>
</template>

<script>
    import ApiRepository from "../../repositories/api.repository";

    export default {
        data() {
            return {
                sitionColor: '#ff8800',
                //booleans
                isLoading: true,

                //Sources
                apiData: null,

                availableProjects: [],
                selectedProject: undefined,

                availableApi: ['Shopware6', 'Exact Online', 'SnelStartV2'],
                selectedApi: "Shopware6",

                //Chart Series
                callHistoryChartSeries: [0, 0, 0, 0, 0, 0, 0],
                dailyCallChartSeries: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],

                //Chart Options
                callHistoryChartOptions: {
                    chart: {
                        id: 'callChart',
                        toolbar: {
                            show: false
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    annotations: {
                        yaxis: [
                            {
                                borderColor: '#e30004',
                                strokeDashArray: 0,
                                label: {
                                    borderColor: '#e30004',
                                    style: {
                                        fontSize: '12px',
                                        color: '#fff',
                                        background: '#e30004'
                                    },
                                    text: 'API-call Limit per day: ' + 50000,
                                }
                            }
                        ]
                    },
                    stroke: {
                        curve: 'stepline',
                    },
                    markers: {
                        size: 4,
                    },
                    xaxis: {
                        categories: [],
                        labels: {
                            show: true,
                            rotate: -10,
                            rotateAlways: true
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'Amount of calls'
                        },
                        forceNiceScale: true
                    },
                    colors: ['#ff8800', "#FF0000"],
                    legend: {
                        show: false
                    },
                },
                dailyCallChartOptions: {
                    chart: {
                        id: 'callGraph',
                        toolbar: {
                            show: false
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    colors: ['#ff8800'],
                    xaxis: {
                        title: {
                            text: 'Time of day',
                            offsetY: 10
                        },
                        categories: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00']
                    },
                    stroke: {
                        curve: 'stepline',
                    },
                    markers: {
                        size: 4,
                    },
                    yaxis: {
                        title: {
                            text: 'Amount of calls',
                        },
                        min: 0,
                        forceNiceScale: true
                    }
                },
            }
        },
        created() {
            this.refreshAllData();
        },
        methods: {
            updateCharts() {
                if (this.apiData == null)
                    return;

                this.isLoading = true;
                this.callHistoryChartOptions.xaxis.categories = Object.keys(this.apiData['dataHistory'][this.selectedProject][this.selectedApi]);
                this.callHistoryChartOptions.annotations.yaxis[0]['borderColor'] = '#e30004';
                this.callHistoryChartOptions.annotations.yaxis[0]['label']['style']['background'] = '#e30004';
                this.callHistoryChartOptions.annotations.yaxis[0]['label']['borderColor'] = '#e30004';
                if (this.isLimited) {
                    this.callHistoryChartOptions.annotations.yaxis[0]['y'] = 50000;
                } else {
                    this.callHistoryChartOptions.annotations.yaxis[0]['y'] = -50000;
                }

                this.callHistoryChartSeries = [{
                    name: 'Amount Of Calls To ' + this.selectedApi,
                    type: 'line',
                    data: Object.values(this.apiData['dataHistory'][this.selectedProject][this.selectedApi])
                }];

                this.dailyCallChartSeries = [{
                    name: 'Amount Of Calls To ' + this.selectedApi,
                    data: this.apiData['dataToday'][this.selectedProject][this.selectedApi]
                }];
                this.isLoading = false;
            },
            async refreshAllData() {
                let [data, projects] = await Promise.all([ApiRepository.getAllData(), ApiRepository.getAllAvailableProjects()]);

                this.apiData = data.data;
                this.availableProjects = projects.data.projects;
                if (this.selectedProject != null) {
                    this.updateCharts();
                }
            }
        },
        computed: {
            availableProjectNames() {
                let toReturn = [];

                this.availableProjects.map(p => {
                    toReturn.push({value: p.id, text: p.name});
                });

                if (toReturn[0] !== undefined) {
                    this.selectedProject = toReturn[0].value;
                }
                return toReturn;
            },
            availableAPIs() {
                let toReturn = [];
                if (this.apiData == null)
                    return toReturn;
                Object.keys(this.apiData['dataHistory'][this.selectedProject]).map(p => {
                    toReturn.push(p);
                });
                return toReturn;
            },
            callsMadeToday() {
                let val = 0;
                if (this.selectedApi && this.selectedProject) {
                    this.apiData['dataToday'][this.selectedProject][this.selectedApi].forEach(call => val += call);
                }
                return val
            },
            isLimited() {
                return this.selectedApi === "Exact Online";
            },
            loadingData() {
                return this.availableProjectNames.length === 0;
            }
        },
        watch: {
            selectedApi() {
                if (this.apiData !== undefined && this.selectedProject !== undefined) {
                    this.updateCharts();
                }
            },
            selectedProject() {
                if (this.apiData !== undefined && this.selectedApi !== undefined) {
                    this.updateCharts();
                }
            },
        }
    }
</script>

<style scoped>
    .infoBox {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

    .dailyCallCard {
        text-align: center;
        padding: 60px;
    }

    .dailyCallChart {
        width: 80%;
    }

    .dailyCallRatioChart {
        display: flex;
        align-items: center;
        text-transform: capitalize;
        font-weight: bolder;
    }

    .dailyCallDivider {
        margin-left: 20px;
        margin-right: 20px;
    }

    .refreshButton {
        width: 100%;
    }
</style>
